export const definedColors = {
  applied: "#B3D4FF",
  assessment: "#B3F5FF",
  hired: "#BCF8DF",
  offer: "#FFF0B3",
  interview: "#C0B6F2",
  rejected: "#FFBDAD",
};
export const definedTextColors = {
  applied: "#0747A6",
  assessment: "#00A3BF",
  hired: "#006644",
  offer: "#FF991F",
  interview: "#403294",
  rejected: "#D94931",
};
